
/**
 * @description 拖拽组件 目前仅支持移动端事件 用于拖动页面某个元素
 * @author 80003502
 * @date 2018-10-19 10:26
 */
export default {
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      dragElm: '', // 拖拽元素
      minX: 0, // 最小X轴边缘
      minY: 0, // 最小Y轴边缘
      maxX: 0, // 最大X轴边缘
      maxY: 0, // 最大Y轴边缘
      style: '', // 样式对象
      isDone: false, // 是否靠左边 仅 this.config.side === true 时 生效
      isDoneRight: false, // 是否靠右边 仅 this.config.side === true 时 生效
      defaultConfig: {
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: '0rem',
        width: '1.5rem', // 拖拽元素宽
        side: true, // 自动靠边
        zIndex: 1, // 拖拽元素层级
        winWidth: 375, // 窗口宽度 ios outerWidth 为0 需要用innerWidth替代
      },
    }
  },
  watch: {
    config: {
      handler(nv) {
        Object.assign(this.defaultConfig, nv)
        this.style = this.defaultConfig
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    /**
     * 
     */
    init() {
      this.dragElm = this.$refs.drag
      this.winWidth = window.outerWidth || window.innerWidth
      if(this.dragElm){
        this.minX = this.dragElm.clientWidth / 2
        this.minY = this.dragElm.clientHeight * 2
      }
      this.maxX = this.winWidth - this.minX
      this.maxY = (window.outerHeight || window.innerHeight) - this.minY
      Object.assign(this.defaultConfig, this.config)

      this.style = {
        // 拖拽元素的样式
        top: this.defaultConfig.top,
        // left: this.defaultConfig.left,
        right: this.defaultConfig.right,
        // bottom: this.defaultConfig.bottom,
        width: this.defaultConfig.width,
        'z-index': this.defaultConfig.zIndex,
      }
    },
    /**
     * @description 拖拽开始
     * @author 80003502
     * @param event {Object} 事件对象
     * @date 2018-10-19 12:47
     */
    onstart(event) {
      event = event.targetTouches[0]
      this.$emit('dragStart', event)
    },
    /**
     * @description 拖拽中
     * @author 80003502
     * @param event {Object} 事件对象
     * @date 2018-10-19 10:24
     */
    onover(event) {
      event.preventDefault()
      event = event.targetTouches[0]
      let left = event.clientX
      let top = event.clientY
      this.isDone = false
      this.isDoneRight = false
      left = Math.max(this.minX, Math.min(this.maxX, left)) // 限制拖拽X轴范围
      top = Math.max(this.minY, Math.min(this.maxY, top)) // 限制拖拽Y轴范围
      this.style.bottom = 'auto' // 重置bottom 因为会影响top值
      this.dragElm.style.left = left - this.dragElm.clientWidth / 2 + 'px'
      if (this.defaultConfig.onlyRight)
        this.dragElm.style.left =
          this.winWidth - this.dragElm.clientWidth + 'px'
      this.dragElm.style.top = top - this.dragElm.clientHeight / 2 + 'px'
      this.$emit('draging', event)
    },
    /**
     * @description 拖拽结束
     * @author 80003502
     * @param event {Object} 事件对象
     * @date 2018-10-19 12:47
     */
    dragDone(event) {
      event = event.changedTouches[0]
      if (this.defaultConfig.side) {
        const left = event.clientX
        // const top = event.clientY
        if (left < this.winWidth / 2) {
          this.isDone = true
          this.style.left = 0
          if (this.defaultConfig.onlyRight)
            this.style.left = this.winWidth - this.dragElm.clientWidth + 'px'
        } else {
          this.isDoneRight = true
          this.style.left = this.winWidth - this.dragElm.clientWidth + 'px'
        }
        // top = Math.max(this.minY, Math.min(this.maxY, top)) // 限制拖拽Y轴范围
        // this.style.top = top - this.dragElm.clientHeight / 2 + 'px'
        setTimeout(() => {
          this.dragElm.style.left = this.style.left
        }, 100)
        this.$emit(
          'dragDone',
          event,
          left < this.winWidth / 2 ? 'left' : 'right'
        )
      } else {
        this.$emit('dragDone', event)
      }
    },
  },
}
